export const DEFAULT_DATE_FORMAT = "DD.MM.YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";

export const DEFAULT_BACKEND_DATE_FORMAT = "YYYY-MM-DD";

export const DEFAULT_BACKEND_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
